import { render } from "./CarregarPessoaFisica.vue?vue&type=template&id=3ebcce25&scoped=true"
import script from "./CarregarPessoaFisica.vue?vue&type=script&lang=js"
export * from "./CarregarPessoaFisica.vue?vue&type=script&lang=js"

import "./CarregarPessoaFisica.vue?vue&type=style&index=0&id=3ebcce25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebcce25"]])

export default __exports__